import { getListResults } from 'redux-list';
import { createSelector } from 'reselect';
import at from 'sportnet-utilities/lib/at';
import { entitiesSelector } from '../../containers/App/selectors';

export const eventsListSelector = (listName: string) =>
  createSelector(
    entitiesSelector,
    getListResults(listName),
    (entities, ids) => {
      return at(entities.events, ids || []);
    },
  );

export const eventByIdSelector = (eventId: string) =>
  createSelector(
    entitiesSelector,
    entities => entities.events[eventId] || null,
  );
